import React, { useState } from 'react';
import Slider from 'react-slick';
import makeRequest from 'utils/makeRequest';
import AdCaller from 'helpers/ads/adCaller';
import EtimesTabs from 'components_etimes/common/Tabs/EtimesTabs';
//import s from '../../layouts/desktop/EtimesListing.scss';
import NewStoryCard from '../../../components_v2/desktop/NewStoryCard';
import SectionHeader from '../../../components_v2/common/SectionHeader';
// import HeaderTab from '../../../home/components/desktop/HeaderTabV2/HeaderTab';
import CapsuleNew from '../../../components_v2/common/CapsuleNew';
import LoaderSpinner from '../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import Morebtn from '../../../components_v2/mobile/Morebtn';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

const settings = {
  dots: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  infinite: false,
};

const renderAds = (adObject, index) => (
  <AdCaller
    skipReRender
    data={{
      groupName: 'mrecs',
      ...adObject,
    }}
    msid={`mrec_${index}`}
    key={`${adObject.tn}_${index}`}
    adWapperClass="phShimmer"
  />
);

export const renderStoryCard = (story, ga4Type, shouldNotlazyloadImage) => (
  <ErrorBoundary>
    <NewStoryCard
      title={story?.hl}
      msid={story?.msid || story?.id}
      syn={story?.synopsis || story?.syn}
      isBigHeading={story?.isBigHeading}
      isLarge={story?.isLarge}
      cardType={story?.cardType || story?.tn}
      wu={story?.wu}
      criticRating={story?.criticRating}
      iconClass={story?.iconClass}
      cmstype={story?.cmstype}
      gaIndex={story?.gaIndex}
      ga4Type={ga4Type}
      shouldNotlazyloadImage={shouldNotlazyloadImage}
      ga4Label={story?.ga4Label}
      videoTime={story.videoTime}
      createdTime={story.createdTime}
      createdTime2={story?.createdTime2}
      fromToiPrint={story?.fromToiPrint}
      slikeId={story?.slikeId}
      imagesize={story?.imagesize}
    />
  </ErrorBoundary>
);

const renderCapsuleNew = (item, ga4Type, ga4Category) => (
  <CapsuleNew item={item} ga4Type={ga4Type} ga4Category={ga4Category} />
);

const renderRow = (
  row,
  index,
  ga4Type,
  rhsPrimeStories = false,
  s,
  preloadItemPresent,
) => {
  switch (row.tn) {
    case 'col_7_3':
      return (
        <div
          className={
            row.classNames &&
            Array.isArray(row.classNames) &&
            row.classNames.map(i => s[i]).join(' ')
          }
          key={row.tn}
        >
          {row.items &&
            Array.isArray(row.items) &&
            row.items.length > 0 &&
            row.items.map(
              col =>
                col.items &&
                Array.isArray(col.items) &&
                col.items.length > 0 && (
                  <div
                    className={`${s[col.tn]} ${col.classNames &&
                      Array.isArray(col.classNames) &&
                      col.classNames.map(i => s[i]).join(' ')}`}
                    key={col.tn}
                  >
                    {col.name && <div>{col.name}</div>}
                    {col.items &&
                      Array.isArray(col.items) &&
                      col.items.length > 0 &&
                      col.items.map((it, itIndex) => {
                        if (it.tn === 'ad') {
                          return renderAds(it, index);
                        } else if (
                          it.tn === 'news' &&
                          (rhsPrimeStories || col?.subTn === 'noFiller')
                        ) {
                          return (
                            <div className={s.rhsPrimeStories}>
                              {renderStoryCard(it, ga4Type)}
                            </div>
                          );
                        } else if (it.tn === 'news') {
                          return (
                            <div className={s.fillerCard}>
                              {renderStoryCard(
                                it,
                                ga4Type,
                                preloadItemPresent &&
                                  itIndex === 0 &&
                                  col.tn === 'colLeft',
                              )}
                            </div>
                          );
                        }
                        return null;
                      })}
                  </div>
                ),
            )}
        </div>
      );
    case 'carousel':
      return (
        <div className={`${s.mt24} slick_UI`} key={row.tn}>
          <Slider {...settings}>
            {row.items &&
              Array.isArray(row.items) &&
              row.items.map(it => renderStoryCard(it, ga4Type))}
          </Slider>
        </div>
      );
    case 'items_row':
    case 'colLeft':
    case 'colRight':
      return (
        <ul
          className={
            row.classNames &&
            Array.isArray(row.classNames) &&
            row.classNames.map(i => s[i]).join(' ')
          }
          key={row.tn}
        >
          {row.items &&
            Array.isArray(row.items) &&
            row.items.map(it => {
              if (it.tn === 'ad') {
                return <li key={it.tn}>{renderAds(it, index)}</li>;
              } else if (it.tn === 'news') {
                return <li key={it.tn}>{renderStoryCard(it, ga4Type)}</li>;
              }
              return null;
            })}
        </ul>
      );
    case 'listing':
      return (
        <div className={s.colLeft} key={row.tn}>
          <div className={s.secWrapWs}>
            <ul className={s.listView}>
              {row.items &&
                Array.isArray(row.items) &&
                row.items.map(it => (
                  <li key={it.tn}>{renderStoryCard(it, ga4Type)}</li>
                ))}
            </ul>
          </div>
        </div>
      );
    case 'two_row':
      return (
        <div className={s.colRight} key={row.tn}>
          {row.items &&
            Array.isArray(row.items) &&
            row.items.map(col => (
              <div key={col.name}>
                {col.name && <h3 className={s.pTitle}>{col.name}</h3>}
                <ul className={s.trendingList}>
                  {col.items &&
                    Array.isArray(col.items) &&
                    col.items.map(it => {
                      if (it.tn === 'ad') {
                        return (
                          <li key={`${it.tn}_${index}`}>
                            {renderAds(it, index)}
                          </li>
                        );
                      } else if (it.tn === 'capsule_style') {
                        return (
                          <li key={`${it.tn}_${index}`}>
                            {renderCapsuleNew(it, col.ga4Type, col.ga4Category)}
                          </li>
                        );
                      }
                      return null;
                    })}
                </ul>
              </div>
            ))}
        </div>
      );
    case 'multi_rows_small':
      return (
        <div className={s.colRight} key={row.tn}>
          {row.items &&
            Array.isArray(row.items) &&
            row.items.map(col => (
              <div
                key={col.name}
                className={
                  col.classNames &&
                  Array.isArray(col.classNames) &&
                  col.classNames.map(i => s[i]).join(' ')
                }
              >
                {col.name && (
                  <InViewObserver
                    inViewCallback={() => {
                      if (col.ga4Type) {
                        analyticsWrapper('ga4', {
                          event: 'user_shown',
                          type: `${col.ga4Type}`,
                        });
                      }
                    }}
                  >
                    <h3 className={`${s.pTitle}  ${s.Heading}`}>{col.name}</h3>
                  </InViewObserver>
                )}
                {col.tn === 'listview' && (
                  <ul className={`${s.trendingList}`}>
                    {col.items &&
                      Array.isArray(col.items) &&
                      col.items.map(it => {
                        if (it.tn === 'ad') {
                          return (
                            <li key={`${it.tn}_${index}`}>
                              {renderAds(it, index)}
                            </li>
                          );
                        } else if (it.tn === 'news') {
                          return (
                            <li key={`${it.tn}_${index}`}>
                              {renderStoryCard(it, ga4Type)}
                            </li>
                          );
                        }
                        return null;
                      })}
                  </ul>
                )}
                {col.tn === 'row' && (
                  <>
                    {col.items &&
                      Array.isArray(col.items) &&
                      col.items.map(it => {
                        if (it.tn === 'row') {
                          return (
                            <div
                              key={`${it.tn}_${index}`}
                              className={
                                it.classNames &&
                                Array.isArray(it.classNames) &&
                                it.classNames.map(i => s[i]).join(' ')
                              }
                            >
                              {it.items &&
                                Array.isArray(it.items) &&
                                it.items.map(on => {
                                  if (on.tn === 'news') {
                                    return (
                                      <>{renderStoryCard(on, col.ga4Type)}</>
                                    );
                                  }
                                  return null;
                                })}
                            </div>
                          );
                        } else if (it.tn === 'listview') {
                          return (
                            <ul
                              className={
                                it.classNames &&
                                Array.isArray(it.classNames) &&
                                it.classNames.map(i => s[i]).join(' ')
                              }
                            >
                              {it.items &&
                                Array.isArray(it.items) &&
                                it.items.map(on => {
                                  if (on.tn === 'news') {
                                    return (
                                      <li key={`${on.tn}_${index}`}>
                                        {renderStoryCard(on, col.ga4Type)}
                                      </li>
                                    );
                                  }
                                  return null;
                                })}
                            </ul>
                          );
                        }
                        return null;
                      })}
                  </>
                )}
                {col.tn === 'ad' && (
                  <>
                    {col.items &&
                      Array.isArray(col.items) &&
                      col.items.map(it => {
                        if (it.tn === 'ad') {
                          return <>{renderAds(it, index)}</>;
                        }
                        return null;
                      })}
                  </>
                )}
                {col.path &&
                  !col.noBtn && (
                    <div className={`${s.seeAllBtn}`}>
                      <Morebtn
                        absoluteMoreText={col.btnText}
                        moreLink={col.path}
                        ga4Type={col.ga4Type}
                        ga4Category="cta_click"
                        gaLabel={col.btnText}
                      />
                    </div>
                  )}
              </div>
            ))}
        </div>
      );
    default:
      return null;
  }
};

const CoverLayout = ({ item, index, isPrime, s }) => {
  if (!(item && Array.isArray(item.items))) {
    return null;
  }
  const [isLoading, setIsLoading] = useState(false);
  setTimeout(() => {
    setIsLoading(false);
  }, 60000000);

  const [itemsLoaded, setItemsLoaded] = useState([]);
  const [activeTabPath, setActiveTabPath] = useState('');

  const [activeTab, setActiveTab] = useState(
    Array.isArray(item.subSections) && item.subSections.length
      ? item.subSections[0].name
      : '',
  );

  const loadSectionData = (dataUrl, path) => {
    if (!dataUrl) {
      return;
    }
    if (isPrime) {
      dataUrl += '&pc1=yes';
    }
    setIsLoading(true);
    makeRequest
      .get(dataUrl, {}, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length > 0
        ) {
          setItemsLoaded(data.data.items);
          setIsLoading(false);
          if (path) {
            setActiveTabPath(path);
          }
        } else {
          setIsLoading(false);
          setActiveTabPath(path || item.path);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setActiveTabPath(path || item.path);
      });
  };

  const onTabsChange = params => {
    if (params && params.clickedItem && params.clickedItem.dataUrl) {
      loadSectionData(params.clickedItem.dataUrl, params.clickedItem.path);
    }

    if (params.clickedItem.name) {
      setActiveTab(params.clickedItem.name);
    }
  };

  const itemstoRender =
    Array.isArray(itemsLoaded) && itemsLoaded.length > 0
      ? itemsLoaded
      : item.items;

  return (
    <div
      className={
        item.classNames &&
        Array.isArray(item.classNames) &&
        item.classNames?.map(i => s[i])?.join(' ')
      }
    >
      {isLoading && <LoaderSpinner />}
      {item.name && (
        <SectionHeader
          title={item.name}
          icon={item.icon}
          path={activeTabPath || item.path}
          ga4Type={item.ga4Type}
          sponseredText={item.sponser?.sponseredText}
          sponseredLogo={item.sponser?.sponseredLogo}
          sponseredLink={item.sponser?.sponseredLink}
          shouldNotlazyloadIcon={item.id === 'cinema'}
          ish1={item.ish1}
        >
          {Array.isArray(item.subSections) && (
            <div className={s.tabContainer}>
              <span className={s.line} />
              <EtimesTabs
                tabs={item.subSections}
                ga4Type={item.ga4Type}
                onChangeCallback={onTabsChange}
                active={activeTab}
                numOfMenuItems={item.numOfMenuItems}
              />
            </div>
          )}
        </SectionHeader>
      )}
      <div
        className={
          item.innerClassNames &&
          Array.isArray(item.innerClassNames) &&
          item.innerClassNames?.map(i => s[i])?.join(' ')
        }
      >
        {itemstoRender &&
          Array.isArray(itemstoRender) &&
          itemstoRender.map(row =>
            renderRow(
              row,
              index,
              item.ga4Type,
              item?.rhsPrimeStories,
              s,
              item.preloadItem && item.preloadItem.msid,
            ),
          )}
      </div>
    </div>
  );
};

export default CoverLayout;
